import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const ShareBtnContainer = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;

  gap: 8px;
  @media (min-width: ${DEVICE.laptop}) {
    top: 24px;
  }
`;

export const ShareText = styled.div`
  color: ${({theme}) =>
    theme.hasTemplate
      ? theme.colors.branding.primary
      : theme.colors.buttons.mainButtonBackground};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
